"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSamePolygon = exports.getViewBoxVertices = exports.convertScreenXYToLatLng = void 0;
var convertScreenXYToLatLng = function (_a, gmap) {
    var x = _a.x, y = _a.y;
    var scale = 1 << gmap.getZoom();
    var mapProjection = gmap.getProjection();
    var top = mapProjection.fromLatLngToPoint(gmap.getBounds().getNorthEast());
    var bottom = mapProjection.fromLatLngToPoint(gmap.getBounds().getSouthWest());
    var newLatlng = mapProjection.fromPointToLatLng(new google.maps.Point(x / scale + bottom.x, y / scale + top.y));
    return {
        lat: newLatlng.lat(),
        lng: newLatlng.lng(),
    };
};
exports.convertScreenXYToLatLng = convertScreenXYToLatLng;
var getViewBoxVertices = function (bounds) {
    var viewBox = [
        [
            // North east
            [bounds['north'], bounds['east']],
            // South east
            [bounds['south'], bounds['east']],
            // South west
            [bounds['south'], bounds['west']],
            // North west
            [bounds['north'], bounds['west']],
            // North east
            [bounds['north'], bounds['east']],
        ],
    ];
    return viewBox.map(function (poly) {
        return poly.map(function (coords) { return [Number(coords[0]), Number(coords[1])]; });
    });
};
exports.getViewBoxVertices = getViewBoxVertices;
var isSamePolygon = function (geoPoly1, geoPoly2) {
    var poly1 = geoPoly1[0];
    var poly2 = geoPoly2[0];
    if (poly1.length != poly2.length) {
        return false;
    }
    var isSame = true;
    var hashFn = function (coords) {
        return coords[0] + ' ' + coords[1];
    };
    var hashPoly1 = poly1.map(hashFn);
    var hashPoly2 = poly2.map(hashFn);
    for (var i = 0; i < hashPoly1.length; i++) {
        if (hashPoly2.indexOf(hashPoly1[i]) === -1) {
            isSame = false;
            break;
        }
    }
    return isSame;
};
exports.isSamePolygon = isSamePolygon;
